import React from "react";
import { ChangePasswordForm } from "@/pages/ChangePasswordForm";

type Props = {
    phoneNumber: string;
    oldPassword: string;
    onCancel: () => void;
    onSuccess: (newPassword: string) => void;
};

export const ChangePasswordPage: React.FC<Props> = ({
                                                        phoneNumber,
                                                        oldPassword,
                                                        onCancel,
                                                        onSuccess,
                                                    }) => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-slate-950 px-4">
            <div className="w-full max-w-sm rounded-2xl border border-slate-800 bg-slate-900/80 p-6 shadow-xl">
                <h1 className="text-lg font-semibold text-slate-50 text-center mb-1">Смена пароля</h1>
                <p className="text-[11px] text-slate-400 text-center mb-4">
                    Телефон: <span className="text-slate-200">{phoneNumber}</span>
                </p>

                <ChangePasswordForm
                    phoneNumber={phoneNumber}
                    oldPasswordPrefill={oldPassword}
                    onCancel={onCancel}
                    onSuccess={onSuccess}
                />
            </div>
        </div>
    );
};
